import { StatusChip, appointmentStatusSemantic } from '@scripsteam/scrips-signal-ds';

/**
 * AppointmentStatusBadge — the patient appointment surfaces (Appointments tab, its filter bar and
 * the chart Appointments tab) show an appointment status as the one soft status chip: the
 * semantic tint behind the semantic text, never solid. The semantic comes from the DS's single
 * appointment-status map (`appointmentStatusSemantic`, the same map the calendar reads), so a
 * status keeps one colour everywhere; an unknown server status falls to neutral grey and its
 * raw text stays visible. The chip's geometry (20 tall, 13 px label) is the bridge's
 * `/* status chip *\/` block; no look is set here.
 */
export function AppointmentStatusBadge({ status }: { status: string | null }) {
  if (!status) return <span className="text-text-hint">—</span>;
  return (
    <StatusChip semantic={appointmentStatusSemantic(status)} tone="soft">
      {/* Same wording as before: the DS StatusBadge showed Fulfilled as Completed. */}
      {/^fulfilled$/i.test(status) ? 'Completed' : status}
    </StatusChip>
  );
}
